import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceMastertablesComponent } from "./maintenance-mastertables.component";
import { CreateEditMastertablesComponent } from "./create-edit-data-mastertables/create-edit-mastertables.component";
import { ListMastertablesComponent } from "./list-mastertables/list-mastertables.component";
import { CreateMastertablesComponent } from "./create-mastertables/create-mastertables.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesMastertables: Routes = [
  {
    path: "mastertablas-gestion-sistema",
    component: MaintenanceMastertablesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListMastertablesComponent,
        data: {
          type: "S",
        },
      },
      {
        path: "creacion/:mastertable",
        component: CreateEditMastertablesComponent,
        data: {
          operation: "creacion",
          type: "S",
        },
      },
      {
        path: "edicion/:mastertable/:id",
        component: CreateEditMastertablesComponent,
        data: {
          operation: "edicion",
          type: "S",
        },
      },
      {
        path: "creacion",
        component: CreateMastertablesComponent,
        data: {
          type: "S",
        },
      },
    ],
  },
  {
    path: "mastertablas-datos-tecnicos-vehículo",
    component: MaintenanceMastertablesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListMastertablesComponent,
        data: {
          type: "D",
        },
      },
      {
        path: "creacion/:mastertable",
        component: CreateEditMastertablesComponent,
        data: {
          operation: "creacion",
          type: "D",
        },
      },
      {
        path: "edicion/:mastertable/:id",
        component: CreateEditMastertablesComponent,
        data: {
          operation: "edicion",
          type: "D",
        },
      },
      {
        path: "creacion",
        component: CreateMastertablesComponent,
        data: {
          type: "D",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesMastertables)],
  exports: [RouterModule],
})
export class MastertablesRoutingModule {}
